import { Center } from 'styled-system/jsx';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';

type LoadingPageProps = {
  height?: string;
};

const LoadingPage = ({ height = '70vh' }: LoadingPageProps) => {
  return (
    <Center height={height}>
      <CircularLoading color="colors.purple-primary" />
    </Center>
  );
};
export default LoadingPage;
